/**
*  TheLimitRangeInput.vue of project WeTradeWeb
*  @date 2022/5/27 23:53
*  @author 阿佑[ayooooo@petalmail.com]
*/
<template>
<RangeInput #="{ value }" :max="200" :min="min" :step="5" :value="value"
  class="bg-white br-lg p-8 range c-text f-bold" style="width: 165px">
  <slot :value="value">
    -{{value}}%
  </slot>
</RangeInput>
</template>

<script lang="ts">
import RangeInput from '@/components/RangeInput.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TheLimitRangeInput',
  components: { RangeInput },
  props: {
    min: {
      type: Number,
      default: 10,
    },
    value: Number,
  },
})
</script>
